import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import warning from 'warning';
import locale from '../locale';
import AdvancedPortal from '../core/AdvancedPortal';

var Loading = /*#__PURE__*/function (_React$Component) {
  _inherits(Loading, _React$Component);

  var _super = _createSuper(Loading);

  function Loading(props) {
    var _this;

    _classCallCheck(this, Loading);

    _this = _super.call(this, props);
    _this.body = document.body || document.documentElement; // TODO: 为了避免与业务样式冲突，应该使用 class

    _this.disableScroll = function () {
      _this.body.style.setProperty('overflow', 'hidden');
    };

    _this.enableScroll = function () {
      _this.body.style.removeProperty('overflow');
    };

    _this.renderLoadingContent = function () {
      var _a = _this.props,
          fullscreen = _a.fullscreen,
          show = _a.show,
          visible = _a.visible,
          backdrop = _a.backdrop,
          backdropClassName = _a.backdropClassName,
          backdropStyle = _a.backdropStyle,
          className = _a.className,
          iconType = _a.iconType,
          text = _a.text,
          lock = _a.lock,
          iconWhite = _a.iconWhite,
          zIndex = _a.zIndex,
          popupContainer = _a.popupContainer,
          containClassName = _a.containClassName,
          icon = _a.icon,
          otherProps = __rest(_a, ["fullscreen", "show", "visible", "backdrop", "backdropClassName", "backdropStyle", "className", "iconType", "text", "lock", "iconWhite", "zIndex", "popupContainer", "containClassName", "icon"]);

      var v = visible || show;
      return /*#__PURE__*/React.createElement("span", {
        className: classNames(['roo-loading', {
          'full-screen': fullscreen
        }, {
          hidden: !v
        }])
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(['backdrop', {
          hidden: !backdrop
        }, backdropClassName]),
        style: backdropStyle
      }), /*#__PURE__*/React.createElement("div", _Object$assign({
        className: classNames(['loading-box', className])
      }, otherProps), _this.renderIcon(), /*#__PURE__*/React.createElement("div", {
        className: "loading-tip"
      }, text)));
    };

    if (props.show) {
      warning(false, 'Roo Loading: `show` 即将被舍弃，请使用 `visible`');
    }

    return _this;
  }

  _createClass(Loading, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          show = _this$props.show,
          visible = _this$props.visible,
          lock = _this$props.lock;
      var v = visible || show;

      if (lock && !v) {
        this.enableScroll();
      } else if (lock && v) {
        this.disableScroll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.enableScroll();
    }
  }, {
    key: "renderDotList",
    value: function renderDotList(dotLen) {
      var dotList = [];

      for (var index = 0; index < dotLen; index++) {
        // dot-index的形式避免报warning
        dotList.push( /*#__PURE__*/React.createElement("div", {
          key: "dot-".concat(index),
          className: "loading-item".concat(index, " loading-item")
        }));
      }

      return dotList;
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _this$props2 = this.props,
          icon = _this$props2.icon,
          iconType = _this$props2.iconType;
      if (icon) return this.renderCustomIcon();
      if (iconType === 'primary') return this.renderPrimary();
      return this.renderNormal();
    }
  }, {
    key: "renderCustomIcon",
    value: function renderCustomIcon() {
      var icon = this.props.icon;
      return /*#__PURE__*/React.createElement("div", null, icon);
    }
  }, {
    key: "renderPrimary",
    value: function renderPrimary() {
      var iconWhite = this.props.iconWhite;
      return /*#__PURE__*/React.createElement("div", {
        className: "primary loading-icon ".concat(iconWhite ? 'white' : 'black')
      }, this.renderDotList(8));
    }
  }, {
    key: "renderNormal",
    value: function renderNormal() {
      var _this$props3 = this.props,
          iconType = _this$props3.iconType,
          iconWhite = _this$props3.iconWhite;
      var iconColor = iconWhite ? 'white' : 'black';
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(iconType, " loading-pt ").concat(iconColor)
      }, this.renderDotList(12));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          show = _this$props4.show,
          visible = _this$props4.visible,
          fullscreen = _this$props4.fullscreen,
          popupContainer = _this$props4.popupContainer,
          zIndex = _this$props4.zIndex,
          containClassName = _this$props4.containClassName;
      var v = visible || show;

      if (fullscreen) {
        return /*#__PURE__*/React.createElement(AdvancedPortal, {
          position: "fixed",
          visible: v,
          zIndex: zIndex,
          container: popupContainer
        }, this.renderLoadingContent(), this.props.children);
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        },
        className: containClassName
      }, this.renderLoadingContent(), this.props.children);
    }
  }]);

  return Loading;
}(React.Component);

Loading.propTypes = {
  lock: PropTypes.bool,
  backdrop: PropTypes.bool,
  show: PropTypes.bool,
  visible: PropTypes.bool,
  text: PropTypes.string,
  fullscreen: PropTypes.bool,
  iconType: PropTypes.oneOf(['primary', 'circle', 'vline', 'hline']),
  iconWhite: PropTypes.bool,
  backdropStyle: PropTypes.object,
  backdropClassName: PropTypes.string,
  className: PropTypes.string,
  containClassName: PropTypes.string,
  zIndex: PropTypes.number,
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};
Loading.defaultProps = {
  lock: false,
  backdrop: false,
  show: false,
  visible: false,
  text: locale.lng('Loading.text'),
  fullscreen: false,
  iconType: 'primary',
  iconWhite: false,
  backdropStyle: undefined,
  backdropClassName: '',
  containClassName: '',
  className: '',
  zIndex: 1000,
  popupContainer: document.body,
  icon: undefined
};
export default Loading;